var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-full w-full flex flex-column"},[_vm._t("header"),_c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"grid"},[_vm._t("side"),_vm._t("default")],2)])],2)}
var staticRenderFns = []

export { render, staticRenderFns }